import { CircularProgress } from '@mui/material'

export default function FallBackComponent() {
  return (
    <div className='w-full h-[100vh] flex items-center justify-center'>
        <CircularProgress/>
    </div>
  )
}
